import { createTheme, ThemeProvider } from '@mui/material/styles';
import Map from './map.page';

const theme = createTheme({
    typography: {
        allVariants: {
            fontFamily: "'Montserrat', sans-serif"
        }
    },
    palette: {
        primary: {
            main: '#002A4D'
        },
        green: {
            main: '#4CA341'
        },
        yellow: {
            main: '#FFAE07'
        },
        red: {
            main: '#DA1F33'
        },
        white: {
            main: '#FFFFFF'
        }
    }
});

const MapEmbed = () => {
    return (
        <div style={{ height: '100vh' }}>
            <ThemeProvider theme={theme}>
                <Map />
            </ThemeProvider>
        </div>
    );
};

export default MapEmbed;
